/**
 * @generated SignedSource<<45171f46c50aa773456ca94a51e3974f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type approvalDrawer_softwareReleasesApprovers_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"removeApprover_softwareReleasesApprovers_jiraVersion">;
  readonly " $fragmentType": "approvalDrawer_softwareReleasesApprovers_jiraVersion";
};
export type approvalDrawer_softwareReleasesApprovers_jiraVersion$key = {
  readonly " $data"?: approvalDrawer_softwareReleasesApprovers_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"approvalDrawer_softwareReleasesApprovers_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "approvalDrawer_softwareReleasesApprovers_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "removeApprover_softwareReleasesApprovers_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "6da0d1cd4c994248c69b351953b6d2d6";

export default node;
